import React, { Component } from "react";
import Prompt from "../components/prompt";

class Error extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
       <Prompt path='//j1.58cdn.com.cn/arthurupload/arthurlocalpush/ysk/icon404.png' tip={"网络异常，请检查网络~"} />
      </div>
    );
  }
}

export default Error;
